import { v2_useCart } from '@crocodille/common';
import { isSome } from '@crocodille/util';
import BBLogo from '@components/bb-logo/bb-logo';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import * as routing from '../../routing';
import styles from './app-layout.module.scss';

const AppLayoutHeaderLogo: React.FC = () => {
  const hasOrder = isSome(v2_useCart().data);

  const { push } = useRouter();

  return (
    <Link
      href={routing.shippingRoute({ shipping: 'courier' })}
      prefetch={false}
      className={styles.logoLink}
      onClick={(e) => {
        e.preventDefault();

        push(
          hasOrder
            ? routing.menu()
            : routing.shippingRoute({ shipping: 'courier' }),
        );
      }}
    >
      <BBLogo />
    </Link>
  );
};

export default AppLayoutHeaderLogo;
